import React from 'react'

export default function pdfToImage(props) {
  const { className } = props

  return (
    <div className={className ? className : ''}>
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 36">
        <g class="Frame" clip-path="url(#a)">
          <g class="Group 48">
            <g class="Group 47">
              <path
                fill="currentColor"
                fill-opacity=".1"
                d="M30.7 6.2 25.4 1c-.3-.3-.7-.5-1.1-.4h-16c-1.1 0-2 .9-2 2v17c.3 0 .7-.1 1-.1 5.1-.1 9.3 4 9.4 9.1 0 .9-.1 1.8-.4 2.7h12.9c1.1 0 2.1-.9 2.1-2v-22c-.1-.4-.3-.8-.6-1.1Z"
                class="Vector"
                opacity=".1"
              />
              <path
                fill="currentColor"
                d="M31.2 5.8 26 .7c-.5-.4-1.1-.7-1.8-.7H8.6c-1.7 0-3 1.3-3.1 2.9v16.8c.3-.1.7-.1 1-.2V3c0-1.1.9-2 2-2h15.7c.4 0 .8.2 1.1.4l5.2 5.1c.3.3.5.7.5 1.1V29c0 1.1-.9 2-2 2H16.3c-.1.3-.2.7-.3 1h13c1.7 0 3-1.3 3-3V7.6c0-.7-.3-1.3-.8-1.8Z"
                class="Vector"
              />
            </g>
            <g class="Vector">
              <path
                fill="currentColor"
                d="M7.5 30H4c-.3 0-.5-.2-.5-.4v-2.1c0-.3.2-.5.4-.5h3.6v-2.3c0-.1.1-.2.2-.2s.1 0 .2.1l4.2 3.9c.1.1.1.2 0 .3l-4.2 3.8c-.1.1-.2.1-.3 0l-.1-.1V30Zm0-9C3.4 21 0 24.3 0 28.5S3.3 36 7.5 36s7.5-3.3 7.5-7.5c-.1-4.1-3.4-7.4-7.5-7.5Z"
              />
              <path
                fill="currentColor"
                fill-opacity=".1"
                d="M7.5 30H4c-.3 0-.5-.2-.5-.4v-2.1c0-.3.2-.5.4-.5h3.6v-2.3c0-.1.1-.2.2-.2s.1 0 .2.1l4.2 3.9c.1.1.1.2 0 .3l-4.2 3.8c-.1.1-.2.1-.3 0l-.1-.1V30Z"
              />
            </g>
          </g>
          <g class="Group 59">
            <path
              fill="currentColor"
              d="M20 10.417a2.34 2.34 0 0 0 1.111-.274c.329-.178.585-.432.737-.73a1.35 1.35 0 0 0 .114-.938 1.56 1.56 0 0 0-.548-.832 2.176 2.176 0 0 0-1.024-.445 2.432 2.432 0 0 0-1.155.093 1.968 1.968 0 0 0-.898.598c-.22.267-.337.582-.337.903 0 .431.21.844.586 1.149.375.305.884.476 1.414.476Zm0-2.167a.78.78 0 0 1 .37.092c.11.06.195.144.246.243a.45.45 0 0 1 .038.313.52.52 0 0 1-.183.277.725.725 0 0 1-.34.148.81.81 0 0 1-.386-.03.656.656 0 0 1-.3-.2.473.473 0 0 1-.112-.301c0-.144.07-.281.196-.383A.752.752 0 0 1 20 8.25Z"
              class="Vector"
            />
            <path
              fill="currentColor"
              d="M24.667 5H11.333c-.353 0-.692.114-.943.317-.25.203-.39.479-.39.766v10.834c0 .287.14.563.39.766.25.203.59.317.943.317h13.334c.353 0 .692-.114.942-.317s.391-.479.391-.766V6.083c0-.287-.14-.563-.39-.766A1.504 1.504 0 0 0 24.666 5Zm0 11.917H11.333v-3.25l3.334-2.709 3.726 3.028c.25.202.588.315.94.315.353 0 .69-.113.94-.315l1.06-.861 3.334 2.708v1.084Zm0-2.617-2.394-1.944a1.505 1.505 0 0 0-.94-.315c-.352 0-.69.113-.94.315l-1.06.861-3.726-3.028a1.504 1.504 0 0 0-.94-.315c-.353 0-.69.113-.94.315l-2.394 1.945v-6.05h13.334V14.3Z"
              class="Vector"
            />
          </g>
        </g>
      </svg>
    </div>
  )
}
